import React from "react"
import s from "./SystemInfo.less"

const SystemInfo = () => {
  return (
    <div className={s.root}>
      <p>
        If you want to access old version of dashboard,{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://olddashboard.vrallart.com"
        >
          click here.
        </a>{" "}
        If you encounter any technical issues or bugs, please let us know at{" "}
        <a href="mailto:dashboard@vrallart.com">dashboard@vrallart.com</a>
      </p>
    </div>
  )
}

export default SystemInfo
